const marquees = document.querySelectorAll('.marquee');

// Respect the user preference regarding the reduced motions
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  addAnimation();
}

function addAnimation() {
  marquees.forEach(marquee => {
    marquee.setAttribute('data-animated', true);

    const marqueeInner = marquee.querySelector('.marquee__inner');
    const marqueeContent = Array.from(marqueeInner.children);

    marqueeContent.forEach(item => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute('aria-hidden', true);
      marqueeInner.appendChild(duplicatedItem);
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/marquee.js